import styled from "styled-components"

export const FormWrapper = styled.div`
  * {
    margin: 10px 0;
  }
  .MuiFormControl-root {
    width: 100%;
  }
` 